import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

// Form control
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntypedFormControl, FormGroupDirective, NgForm, Validators, AbstractControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

// Angular material components
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';

// Custom services
import { ControllerService } from '../../../services/controller/controller.service';
import { LanguageService } from '../../../services/language/language.service';
import { UtilsService } from '../../../services/utils/utils.service';

// Custom components
import { WaitingPopupComponent } from '../../popups/waiting-popup/waiting-popup.component';

// Constant configuration values
import { configurationValues } from '../../../constants/global';

/* Error when invalid control is dirty, touched, or submitted (input fields) */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Component({
  selector: 'app-individual-users',
  imports: [
    // Angular modules
    MatTabsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatListModule,
    MatDividerModule,
    // Custom modules
    WaitingPopupComponent,
  ],
  templateUrl: './individual-users.component.html',
  styleUrl: './individual-users.component.css'
})
export class IndividualUsersComponent {

  // Waiting popup info
  displayWaitingPopup = false
  waitingMessage = ''

  // Confirmation popup info
  confirmationPopupData:any = null

  // Menu and list values
  //  New user
  result_password:string = ''
  optionMenu_Region_value_NewUser:string = ''
  optionMenu_LanguageCode_value_NewUser:string = ''
  optionMenu_Region_OptionList = configurationValues.regionList
  optionMenu_LanguageCode_OptionList = configurationValues.languageList
  //  Existing users
  optionMenue_Region_value_ExistingUsers:string = ''
  list_ExistingUsers = []


  // Form controls
  formControl_email = new UntypedFormControl('', [
    Validators.required,
    Validators.email,
    this.spacesInStringValidators.bind(this),
  ]); 
  // Form control group (need to keep this name cause its binded to parents form control)
  //    It needs to be created before constructing and initializing the view  
  formControlGroup = new UntypedFormGroup({
    email: this.formControl_email,
  }, {});
  // Error matcher
  matcher = new MyErrorStateMatcher();


  // Constructor
  constructor(
    public controllerService:ControllerService,
    public languageService:LanguageService,
    public utilsService:UtilsService
  ){}



  // ----- Action buttons (New User) ----- //
  optionMenuClick_Region_NewUser(item:any){
    this.optionMenu_Region_value_NewUser = item
  }
  optionMenuClick_LanguageCode_NewUser(item:any){
    this.optionMenu_LanguageCode_value_NewUser = item
  }
  formIsValid(){
    // Verify that the region is correctly selected
    if(!this.optionMenu_Region_OptionList.includes(this.optionMenu_Region_value_NewUser)){
      return false
    }
    // Verify that the language code is corrected selected
    if(!this.optionMenu_LanguageCode_OptionList.includes(this.optionMenu_LanguageCode_value_NewUser)){
      return false
    }
    // Verify that the email is valid
    if(!this.formControl_email.valid){
      return false
    }
    // Return true otherwise
    return true
  }

  async buttonClicked_craeteLicense(){
    // Display the waiting popup
    this.waitingMessage = this.languageService.Strings.messages.info_creatingLicense
    this.displayWaitingPopup = true
    // Carry out the request and wait for the result
    const email = this.formControl_email.value
    const region = this.optionMenu_Region_value_NewUser
    const languageCode = this.optionMenu_LanguageCode_value_NewUser
    const resultDict = await this.controllerService.newUser_individual(email, region, languageCode)
    // Stop the waiting popup
    this.displayWaitingPopup = false
    // Manage errors
    if(!resultDict['success']){
      // TODO: Manage specific errors
      return this.utilsService.displayErrorPopup(this.languageService.Strings.errors.action_unableToCreateLicense)
    }
    // Display password
    this.result_password = resultDict['result']['password']
    this.utilsService.displaySuccessPopup(this.languageService.Strings.messages.info_licenseCreated)
  }

  buttonClicked_copyPasswordToClipboard(){
    this.utilsService.copyToClipboard(this.result_password)
  }



  // ----- Action buttons (Existing Users) ----- //
  async optionMenuClick_Region_ExistingUsers(region:string){
    // Display the waiting popup
    this.waitingMessage = this.languageService.Strings.messages.info_gettingLicenses
    this.displayWaitingPopup = true
    // Carry out the request and wait for the result
    const resultDict = await this.controllerService.listUsers_individual(region)
    // Stop the waiting popup
    this.displayWaitingPopup = false
    // Manage errors
    if(!resultDict['success']){
      // TODO: Manage specific errors
      return this.utilsService.displayErrorPopup(this.languageService.Strings.errors.action_unableToGetLicenses)
    }
    // Manage success
    this.optionMenue_Region_value_ExistingUsers = region
    this.list_ExistingUsers = resultDict['result']
  }

  buttonClicked_userSettings(item: string) {
    console.log("Configurar", item);
  }

  async buttonClicked_deleteUser(item: string) {
    // Get the user email
    const email = item
    // Dangerous action - Display decision popup
    this.confirmationPopupData = email
    const popupTitle = this.languageService.Strings.messages.popupTitle_genericDangerous
    const popupText = `${this.languageService.Strings.messages.confirmation_deleteLicense} ${email}`
    this.utilsService.displayDecisionPopup(popupTitle, popupText, this.buttonClicked_deleteUser_callback.bind(this))
  }

  async buttonClicked_deleteUser_callback(shouldGoOn:boolean){
    // Check if the action is to be executed
    if(!shouldGoOn){
      this.confirmationPopupData = null
      return
    } 
    // Execute the action
    //  Get the user email
    const email = this.confirmationPopupData
    this.confirmationPopupData = null
    //  Display the waiting popup
    this.waitingMessage = this.languageService.Strings.messages.info_deletingLicense
    this.displayWaitingPopup = true
    //  Carry out the request and wait for the result
    let resultDict = await this.controllerService.deleteUser_individual(email, this.optionMenue_Region_value_ExistingUsers)
    //  Manage errors
    if(!resultDict['success']){
      // Stop the waiting popup
      this.displayWaitingPopup = false
      // TODO: Manage specific errors
      return this.utilsService.displayErrorPopup(this.languageService.Strings.errors.action_unableToGetLicenses)
    }
    //  Update the waiting popup (updating licenses)
    this.waitingMessage = this.languageService.Strings.messages.info_gettingLicenses
    //  Update license list - carry out the request and wait for the result
    resultDict = await this.controllerService.listUsers_individual(this.optionMenue_Region_value_ExistingUsers)
    //  Stop the waiting popup
    this.displayWaitingPopup = false
    //  Manage errors
    if(!resultDict['success']){
      // TODO: Manage specific errors
      return this.utilsService.displayErrorPopup(this.languageService.Strings.errors.action_unableToGetLicenses)
    }
    //  Manage success
    this.list_ExistingUsers = resultDict['result']
    this.utilsService.displaySuccessPopup(this.languageService.Strings.messages.info_licenseDeleted)
  }







  // ----- Custom validators ------ //

  specialCharactersValidators(control: AbstractControl) {
    //let addmittedCharacters = /^[a-zA-Z0-9_]*$/; // regular expression (solo símbolos a-z, A-Z, 0-9, _)
    let addmittedCharacters = /^[a-zA-Z0-9\t\n ./<>¿?;:"'`¡!@#$%^&*()\[\]{}_+=ºªñÑ,·çüÜ|\\-áéíóúÁÉÍÓÚ-]*$/; // regular expression
    let currentString = control.value
    if(currentString){
      if(currentString.length > 0){
        if(!addmittedCharacters.test(currentString)){
          return { specialCharactersValidationError: true };
        }
      }
    }
    return null;
  }
  spacesInStringValidators(control: AbstractControl) {
    let currentString = control.value
    if(currentString){
      if(currentString.length > 0){
        if(currentString.indexOf(' ') >= 0){
          return { spacesInStringValidationError: true };
        }
      }
    }
    return null;
  }

  // Method to be able to set custom errors comming from firebase into the input boxes to be used in errorMatcher
  //  example: 'firebaseError'
  // The dialog item requires an id
  displayErrorInDialogField(dialogItemId:string, errorType:string){
    var errorDict:any = {}
    errorDict[errorType] = true
    this.formControlGroup.controls[dialogItemId].setErrors(errorDict);
    // Example error dict: ('email', 'firebaseError')
  }

}
